import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { isAndroidTWA } from "@/lib/twa";

const CLIENT = "ca-pub-2737388126817287";

/**
 * Loads Google AdSense (Auto Ads) for logged-out visitors and free users.
 * Never loads for Spark+ members (ad-free is a premium perk) or inside the
 * Android TWA (AdSense web ads in an app wrapper violate AdSense policy —
 * that use case requires AdMob).
 */
export const AdSenseLoader = () => {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (user?.is_premium) return;
    if (isAndroidTWA()) return;
    if (document.getElementById("adsense-script")) return;
    const s = document.createElement("script");
    s.id = "adsense-script";
    s.async = true;
    s.crossOrigin = "anonymous";
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
    document.head.appendChild(s);
  }, [user?.is_premium, loading]);

  return null;
};
